import { useState } from 'react'
import { Box, UnstyledButton, Checkbox, SimpleGrid } from '@mantine/core'

// #1080 案件登録フォームの「スキル」。カテゴリ(キャリア)タブで絞り込んで選択する。
// タブ切り替えはCSSのdisplay切り替えのみで行い、非表示タブのチェック状態もDOMに残す
// (フォーム送信に含める必要があるため、条件付きマウント/アンマウントはしない)。
export default function SkillTabCheckboxGroup({ fieldName, tags = [], itemsByTag = {} }) {
  const [activeTagId, setActiveTagId] = useState(tags[0]?.id)

  return (
    <Box>
      <input type="hidden" name={fieldName} value="" />
      <Box style={{ display: 'flex', gap: 4, borderBottom: '1px solid var(--mantine-color-gray-2)', overflowX: 'auto' }}>
        {tags.map((tag) => (
          <UnstyledButton
            key={tag.id}
            onClick={() => setActiveTagId(tag.id)}
            style={{
              padding: '8px 14px',
              fontSize: 13.5,
              fontWeight: 600,
              whiteSpace: 'nowrap',
              borderBottom: activeTagId === tag.id ? '2px solid var(--mantine-color-brand-6)' : '2px solid transparent',
              color: activeTagId === tag.id ? 'var(--mantine-color-brand-7)' : 'var(--mantine-color-dimmed)',
            }}
          >
            {tag.name}
          </UnstyledButton>
        ))}
      </Box>
      <Box pt="sm">
        {tags.map((tag) => (
          <SimpleGrid
            key={tag.id}
            cols={{ base: 1, xs: 3 }}
            spacing="xs"
            style={{ display: activeTagId === tag.id ? 'grid' : 'none' }}
          >
            {(itemsByTag[tag.id] || []).map((item) => (
              <Checkbox
                key={item.id}
                id={`${fieldName}_${item.id}`}
                name={fieldName}
                value={item.id}
                defaultChecked={item.checked}
                label={item.name}
                size="sm"
                styles={{ body: { alignItems: 'center' }, labelWrapper: { alignItems: 'center' } }}
              />
            ))}
          </SimpleGrid>
        ))}
      </Box>
    </Box>
  )
}
